export const listOfModules = {
  pay: 'Payroll',
  teams: 'Teams',
  projects: 'Projects',
  time: 'Time & Attendance',
};
